export function startImpersonation({ token, mode = 'user', companyId = null, adminToken = null, adminUser = null }) {
  const currentToken = sessionStorage.getItem('jwt');
  const currentUser = adminUser || null;

  localStorage.setItem('admin_token', adminToken || currentToken || '');
  if (currentUser) {
    localStorage.setItem('admin_user', typeof currentUser === 'string' ? currentUser : JSON.stringify(currentUser));
  }

  sessionStorage.setItem('jwt', token);
  localStorage.setItem('impersonating', 'true');
  localStorage.setItem('impersonation_mode', mode);

  if (companyId != null) {
    localStorage.setItem('impersonating_company_id', String(companyId));
  } else {
    localStorage.removeItem('impersonating_company_id');
  }
}

export function clearImpersonationState() {
  localStorage.removeItem('impersonating');
  localStorage.removeItem('impersonation_mode');
  localStorage.removeItem('impersonating_company_id');
}

export function returnToAdmin() {
  const adminToken = localStorage.getItem('admin_token');
  if (!adminToken) return false;

  sessionStorage.setItem('jwt', adminToken);
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
  clearImpersonationState();
  return true;
}
